import React from "react";
import { Navigate } from "react-router-dom";
import useAuthAdmin from "../hooks/useAuthAdmin";

export default function PublicRoutesAdmin({ children }) {
  const isLoggedIn = useAuthAdmin();
  return !isLoggedIn ? children : <Navigate to="/admin/dashboard" />;
}
